export interface IModalButton {
    label: EModalButtonLabel;
    output: EModalOutput;
    style: 'primary' | 'accent' | 'warn';
    isRaised?: boolean;
}

export enum EModalSize {
    SMALL = 'modal-sm',
    LARGE = 'modal-lg',
    EXTRA_LARGE = 'modal-xl',
}

export enum EModalOutput {
    CONFIRM = 'CONFIRM',
    YES = 'YES',
    CLOSE = 'CLOSE',
    NO = 'NO',
    ADD = 'ADD',
    UNDERSTOOD_BUTTON = 'UNDERSTOOD_BUTTON',
    BACK_TO_POLICY_BUTTON = 'BACK_TO_POLICY_BUTTON',
    RESET = 'RESET',
    REMOVE = 'REMOVE',
    BACK = 'BACK'
}

export enum EModalButtonLabel {
    CONFIRM = 'Conferma',
    YES = 'Sì',
    CLOSE = 'Chiudi',
    NO = 'No',
    ADD = 'Aggiungi',
    UNDERSTOOD_BUTTON = 'Ho capito',
    BACK_TO_POLICY_BUTTON = 'Torna alla polizza',
    RESET = 'Reset',
    REMOVE = 'Rimuovi',
    BACK = 'Indietro'
}

export const CONFIRM_BUTTON: IModalButton = {
    label: EModalButtonLabel.CONFIRM,
    output: EModalOutput.CONFIRM,
    style: 'primary',
    isRaised: true
}

export const YES_BUTTON: IModalButton = {
    label: EModalButtonLabel.YES,
    output: EModalOutput.YES,
    style: 'primary',
    isRaised: true
}

export const CLOSE_BUTTON: IModalButton = {
    label: EModalButtonLabel.CLOSE,
    output: EModalOutput.CLOSE,
    style: 'warn',
    isRaised: true
}

export const BACK_BUTTON: IModalButton = {
    label: EModalButtonLabel.BACK,
    output: EModalOutput.BACK,
    style: 'primary'
}

export const RESET_BUTTON: IModalButton = {
    label: EModalButtonLabel.RESET,
    output: EModalOutput.RESET,
    style: 'warn',
    isRaised: true
}

export const REMOVE_BUTTON: IModalButton = {
    label: EModalButtonLabel.REMOVE,
    output: EModalOutput.REMOVE,
    style: 'warn',
    isRaised: true
}

export const NO_BUTTON: IModalButton = {
    label: EModalButtonLabel.NO,
    output: EModalOutput.NO,
    style: 'warn',
    isRaised: true
}

export const ADD_BUTTON: IModalButton = {
    label: EModalButtonLabel.ADD,
    output: EModalOutput.ADD,
    style: 'primary',
    isRaised: true
}

export const UNDERSTOOD_BUTTON: IModalButton = {
    label: EModalButtonLabel.UNDERSTOOD_BUTTON,
    output: EModalOutput.UNDERSTOOD_BUTTON,
    style: 'primary',
    isRaised: true
}

export const BACK_TO_POLICY_BUTTON: IModalButton = {
    label: EModalButtonLabel.BACK_TO_POLICY_BUTTON,
    output: EModalOutput.BACK_TO_POLICY_BUTTON,
    style: 'primary',
    isRaised: true
}
